import React, { Component } from 'react';
import { message } from 'antd';
import MachineLogListView from '../views/MachineLogListView';
import { base } from '../../base';

class MachineLogListContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            logs: [],
        };
    }

    handleLogDelete = (id) => {
        console.log(id);
        const extraUser = this.props.extraUser;
        base.remove(`logs/${this.props.extraUser.companyid}/${id}`, function(err) {
            if (!err) {
                message.success('Bitacora Eliminada');
            }
        });
    }

    componentWillMount() {
        this.valuesRef = base.syncState(`logs/${this.props.extraUser.companyid}/`, {
            context: this,
            state: 'logs',
            asArray: true,
            queries: {
                orderByChild: 'machineid',
                equalTo: this.props.machineId,
            },
        });
    }

    componentWillUnmount() {
        base.removeBinding(this.valuesRef);
    }

    render() {
        return (
            <div>
                <MachineLogListView
                    deleteLog={this.handleLogDelete}
                    machineId={this.props.machineId}
                    user={this.props.user}
                    extraUser={this.props.extraUser}
                    logs={this.state.logs}
                />
            </div>
        );
    }
}

export default MachineLogListContainer;



// WEBPACK FOOTER //
// ./src/components/containers/MachineLogListContainer.js